<template>
  <div>
    <div class="menus">
      <!-- <div class="row menu">
        <a class="btn__back btn-link" v-on:click="$parent.nextStep()" v-if="isBr"> 
          {{translation.back_step_by_step}}
          <div class="ribbon">
            <span>{{translation.new}}</span>
          </div>
        </a>
      </div> -->
      <div class="row menu">
        <div class="menu--in">
          <a
            v-if="this.langUser != 'br'"
            class="btn-link"
            href="https://office.builderall.com/br/office/franchise-system/trainings/basic"
          >{{translation.affiliate_training}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/franchise-system/messages"
          >{{translation.email_sms}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/franchise-system/quick-start"
          >{{translation.ad_videos}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/franchise-system/share"
          >{{translation.money_making_funnels}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/franchise-system/earn"
          >{{translation.your_gains}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/franchise-system/elearning"
          >{{translation.comunity}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/franchise-system/leads"
          >{{translation.your_leads}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/franchise-system/lead-tree"
          >{{translation.lead_tree}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/franchise-system/webinar"
          >{{translation.weekly_webinar}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/franchise-system/config"
          >{{translation.pixel}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/tax-forms"
          >{{translation.tax_form}}</a>
          <a
            class="btn-link"
            href="https://office.builderall.com/br/office/pages/680"
          >{{translation.gains_calculator}}</a>
          <a
            v-if="this.isAmbassador || this.isAmbassadorPlus"
            class="btn-link"
            @click="AmbassadorPdfs()"
          >{{translation.general_rules}}</a>

          <div class="dropdown">
            <button class="btn">{{translation.app}}</button>
            <ul class="dropdown-menu">
              <li>
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=us.com.builderall.franchise"
                >
                  <i class="icon icon-android"></i>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://itunes.apple.com/us/app/builderall-business/id1413895326"
                >
                  <i class="icon icon-apple"></i>
                </a>
              </li>
            </ul>
          </div>
          <!-- <a href="https://www.facebook.com/groups/133648913954960/" target="_blank">{{translation.title_facebook_group}}</a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "menus",
  components: {},
  data() {
    return {
      translation: this.$parent.$parent.view.translation.menus,
      isAmbassador: null,
      isAmbassadorPlus: null,
      isBr: this.$parent.$parent.view.IS_BR,
      langUser: this.$parent.$parent.view.lang,
    };
  },
  methods: {
    AmbassadorPdfs() {
      window.open(this.$parent.$parent.view.ambassador_pdf.general, "_blank");
      window.open(this.$parent.$parent.view.ambassador_pdf.rules, "_blank");
    }
  },
  mounted() {
    this.isAmbassador = this.$parent.$parent.view.IS_AMBASSADOR
      ? this.$parent.$parent.view.IS_AMBASSADOR
      : false;
    this.isAmbassadorPlus = this.$parent.$parent.view.IS_AMBASSADOR_PLUS
      ? this.$parent.$parent.view.IS_AMBASSADOR_PLUS
      : false;
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// @media (min-width: 992px) {
//   .container {
//       width: 870px !important;
//   }
// }

.menus {
  ul:not(.browser-default) > li {
    list-style-type: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dropdown {
    width: 48%;
    margin-left: 10px;
    button {
      font-size: 1rem;
    }
  }

  .dropdown .dropdown-menu {
    position: absolute;
    top: 100%;
    display: none;
    margin: 0;
    height: 100px;
    top: 65px;
    list-style: none;
    width: 100%;
    padding: 0;
    border: none;
    box-shadow: none;
    background: transparent;
    justify-content: center;
  }

  .dropdown:hover .dropdown-menu {
    display: flex;
  }

  /** Button Styles **/
  .dropdown button {
    display: block;
    background: #f8fafd;
    padding: 1.2rem 1rem;
    color: #818a91;
    margin: 1.1rem 0;
    border-radius: 6px;
    font-weight: 700;
    transition: 0.3s all;
    width: 100%;
    &:hover {
      background: #0294ff;
      color: white;
    }
    &.btn__back {
      width: 100%;
    }
  }

  /** List Item Styles **/
  .dropdown a {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0px 0px 30px -10px;
    padding: 0.2em 0.8em;
    text-decoration: none;
    color: #333333;
    width: 60px;
    height: 60px;
    background-color: white;
  }

  .dropdown a:hover {
    background-color: white;
    box-shadow: 0px 0px 40px -10px;
  }

  .icon {
    content: "";
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 32px;
    width: 32px;
    display: block;
  }
  .icon-android {
    background-image: url(/internacional/public/images/icons/android.svg);
  }
  .icon-apple {
    background-image: url(/internacional/public/images/icons/apple.svg);
  }
}

.menu {
  text-align: center;
  display: flex;
  .btn-link {
    display: block;
    background: #f8fafd;
    padding: 1.2rem 1rem;
    color: #818a91;
    margin: 1.1rem 0;
    border-radius: 6px;
    font-weight: 700;
    transition: 0.3s all;
    width: 48%;
    &:hover {
      background: #0294ff;
      color: white;
    }
    &.btn__back {
      width: 100%;
      position: relative;
      padding: 1.7rem 1rem;
      border-radius: 6px 6px 0 6px;
      .ribbon {
        position: absolute;
        right: -5px;
        top: -5px;
        z-index: 1;
        overflow: hidden;
        width: 75px;
        height: 75px;
        text-align: right;
        span {
          font-size: 10px;
          font-weight: bold;
          color: #fff;
          text-transform: uppercase;
          text-align: center;
          line-height: 20px;
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          width: 100px;
          display: block;
          background: #79a70a;
          background: linear-gradient(#f70505 0%, #8f0808 100%);
          box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
          position: absolute;
          top: 19px;
          right: -21px;
          &::before {
            content: "";
            position: absolute;
            left: 0px;
            top: 100%;
            z-index: -1;
            border-left: 3px solid #8f0808;
            border-right: 3px solid transparent;
            border-bottom: 3px solid transparent;
            border-top: 3px solid #8f0808;
          }
          &::after {
            content: "";
            position: absolute;
            right: 0px;
            top: 100%;
            z-index: -1;
            border-left: 3px solid transparent;
            border-right: 3px solid #8f0808;
            border-bottom: 3px solid transparent;
            border-top: 3px solid #8f0808;
          }
        }
      }
    }
  }
  .menu--in {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/menus.vue